import React from 'react'
import Welcome from './Welcome'

const IndexHomemobile = () => {
  return (
    <div style={{ fontFamily: 'Lato, sans-serif' }}>
      <Welcome/>
    </div>
  )
}

export default IndexHomemobile
